/**
 * Defines the column growing behaviour.
 *
 * __Note:__ Custom cells with components instead of text as children are ignored by the `Smart` and `Grow` modes.
 * __Note:__ For performance reasons, the `Smart` and `Grow` modes base their calculation for table cell width on a subset of column cells. If the first 20 cells of a column are significantly smaller than the rest of the column cells, the content may still not be fully displayed for all cells.
 */
export let AnalyticalTableScaleWidthMode = /*#__PURE__*/function (AnalyticalTableScaleWidthMode) {
  AnalyticalTableScaleWidthMode["Default"] = "Default";
  AnalyticalTableScaleWidthMode["Smart"] = "Smart";
  AnalyticalTableScaleWidthMode["Grow"] = "Grow";
  return AnalyticalTableScaleWidthMode;
}({});